import forOwn from 'mout/object/forOwn'

export default function getBaseQuery(query, nonBaseKey) {
  let baseQuery = ''
  if (query) {
    baseQuery = '?'
    forOwn(query, (val, key) => {
      if (key !== nonBaseKey) {
        baseQuery += `${baseQuery === '?' ? '' : '&'}${key}=${val}`
      }
    })
  }
  return baseQuery
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getBaseQuery.js